import theme from '@trmediaab/theme-storavinster';

import Embed from '../components/Embed';

function StoravinsterPage() {
  return <Embed theme={theme} site="storavinster" />;
}

export default StoravinsterPage;
